// extracted by mini-css-extract-plugin
module.exports = {"flex":"Video_flex__3nHU0","container":"Video_container__16prz"};